import { FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import Iphone from '../../asset/mama/iphone.png';
import Iphone2 from '../../asset/mama/iphone2.png';
import Prize1 from '../../asset/mama/prize1.png';
import Prize2 from '../../asset/mama/prize2.png';
import Prize3 from '../../asset/mama/prize3.png';
import Prize4 from '../../asset/mama/prize4.png';
import Prize5 from '../../asset/mama/prize5.png';
import Prize6 from '../../asset/mama/prize6.png';
// import Close from '../../asset/mama/modal-close-purple.png';
import { t } from 'i18next';
import { useMutation } from 'react-query';
import ModalMultiPrize from '../../asset/mama/modal-multi-prize.png';
import ModalSinglePrize from '../../asset/mama/modal-singe-prize.png';
import PresentImg from '../../asset/mama/present.png';
import RtWheel from '../../asset/mama/rtwheel.png';
import Close from '../../asset/svg/close.svg';
import ErrorIcon from '../../asset/svg/croco-page/error-icon.svg';
import Fire from '../../asset/svg/mama-page/fire.svg';
import HeroCardPink from '../../asset/svg/mama-page/hero-card-pink.svg';
import { CheckBoxElem } from '../../common/checkbox';
import { FieldTextElem } from '../../common/field-text';
import { LoaderElem } from '../../common/loader';
import { SelectElem } from '../../common/select';
import { TextElem } from '../../common/text';
import { getCity } from '../../data/location/action';
import { convertCity } from '../../data/location/convert';
import { getNovaPostWarehouses } from '../../data/novapostwarehouse/action';
import { convertNovapostWarehouses } from '../../data/novapostwarehouse/convert';
import { HttpRequest } from '../../lib/http';
import { SIZE_FONT_ENUM } from '../../theme/size';
import { HeroCard, HeroCardImage, HeroCardText, MamaTextLogo } from '../mama-home/container/home/frame/hero';
import { MamaButton } from '../mama-home/container/promo-button';
import { SelectDynamicContainer } from '../select-dynamic';
import { sendCodesValidationData } from './action';
import { FORM_VALUE_ENUM, SHOP_TYPE_OPTIONS, SOURCE_ENUM } from './constant';
import { WheelAction } from './frame/wheel-santa';

// ─── Types ───────────────────────────────────────────────────────────────────

type Step = 'codes' | 'details' | 'success' | 'wheel';

// ─── Component ───────────────────────────────────────────────────────────────

export const Component: React.FC<{
  formik: FormikValues;
  isFieldError: Function;
  getFieldError: Function;
  setFieldValue: Function;
  isSubmitDisabled: Function;
  getFieldValue: Function;
  isLoading?: boolean;
  isError?: boolean;
  errorMessage?: string;
  isDisabled: Function;
  setValue: Function;
  isSuccess?: boolean;
  prizeData?: any;
  isMultiCode: boolean;
  setIsMultiCode: Function;
  prizeDataForced?: boolean;
}> = ({
  formik,
  isFieldError,
  getFieldError,
  isSubmitDisabled,
  getFieldValue,
  setFieldValue,
  isLoading,
  isError,
  errorMessage,
  isDisabled,
  setValue,
  isSuccess,
  prizeData,
  isMultiCode,
  setIsMultiCode,
  prizeDataForced
}) => {
  const [step, setStep] = useState<Step>('codes'); //codes <-- default   test ---> wheel
  const [isModalOpen, setIsModalOpen] = useState(false); //false <-- default   test ---> true
  const [isWheelSpinning, setIsWheelSpinning] = useState(false);
  const [isWheelSinned, setIsWheelSinned] = useState(false);
  const [codeNotFoundError, setCodeNotFoundError] = useState(false);
  const [isPrizeModalOpen, setIsPrizeModalOpen] = useState(false); // false <-- default   test ---> true
  const wheelRef = useRef<HTMLDivElement>(null);
  const params = new URLSearchParams(window.location.search);
  const source = params.get('source');

  // ── Code validation helpers ───────────────────────────────────────────────

  const isSingleCodeFilled = () => {
    const val = getFieldValue(FORM_VALUE_ENUM.CODE);
    return val && val.length === CODE_LENGTH;
    };

  const isMultiCodeFilled = () => {
    const codes: string[] = getFieldValue(FORM_VALUE_ENUM.CODES) || [];
    return codes.every((c) => c && c.length === CODE_LENGTH);
  };

  // ── Input handlers ────────────────────────────────────────────────────────

  const onChangeName = (e: any) => {
    formik.touched[e.target.name] = true;
      formik.handleChange(e);
    };

  const CODE_LENGTH = 11;
  const MASK_CHAR = '_';

  const cyrillicMap: Record<string, string> = {
    А: 'A', В: 'B', Е: 'E', К: 'K', М: 'M',
    Н: 'H', О: 'O', Р: 'P', С: 'C', Т: 'T', У: 'Y', Х: 'X',
  };

  const applyCodeMask = (val: string) => {
    if (!val) return '';
    const clean = val.slice(0, CODE_LENGTH);
    return clean + MASK_CHAR.repeat(CODE_LENGTH - clean.length);
  };

  const stripMask = (val: string) =>
    val.replace(new RegExp(`[${MASK_CHAR}]`, 'g'), '');

  const replaceCyrillicWithLatin = (s: string) =>
    s.replace(/[А-я]/g, (ch) => cyrillicMap[ch] || ch);

  const onChangeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.touched[e.target.name] = true;
      setCodeNotFoundError(false);

      let raw = stripMask(e.target.value).toUpperCase();
      raw = replaceCyrillicWithLatin(raw).slice(0, CODE_LENGTH);

      // имитируем нативный ивент чтобы formik.handleChange сработал
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value: raw, name: e.target.name },
      };
      formik.handleChange(syntheticEvent);
    };

  const onChangeCodeMasked = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const selectionStart = input.selectionStart ?? 0;

      formik.setFieldTouched(input.name, true);
      setCodeNotFoundError(false);

      let raw = stripMask(input.value).toUpperCase();
      raw = replaceCyrillicWithLatin(raw).slice(0, CODE_LENGTH);

      formik.setFieldValue(input.name, raw);

      // восстанавливаем позицию курсора после рендера
      requestAnimationFrame(() => {
        input.setSelectionRange(selectionStart, selectionStart);
      });
    };

  const onClickBackToSource = () => {
    if (source === SOURCE_ENUM.TELEGRAM) {
      const resolveUrl = 'tg://resolve?domain=nasha_ryaba_promo_bot';
      window.open(resolveUrl, "_blank");
    } else if (source === SOURCE_ENUM.VIBER) {
      const resolveUrl = 'viber://pa?chatURI=nasha_ryaba_promo_bot&context=wheel';
      window.open(resolveUrl, "_blank");
    }
    handleCloseModal();
  }

  // ── Step transitions ──────────────────────────────────────────────────────

  const action = useMutation(sendCodesValidationData, {});

  const getErrorMessage = () => {
    const error: any = action.error as any;

    if (error) {
      return error?.message?.startsWith('ERROR.') ? error?.message?.slice(6) : error?.message;
    }
    //@ts-ignore
    if (action?.data?.response?.statusCode == 400 && !error) {
      //@ts-ignore
      return action?.data?.response?.message;
    }

    return error?.code;
  };

  const handleCodeSubmit = async (isMulti: boolean) => {

    try {
      setCodeNotFoundError(false);
      await action.mutate({
        codes: isMulti ? getFieldValue(FORM_VALUE_ENUM.CODES) : [getFieldValue(FORM_VALUE_ENUM.CODE)],
        promoId: getFieldValue(FORM_VALUE_ENUM.PROMO_ID)
      }, {
        onSuccess: () => {
          setIsMultiCode(isMulti);
          setStep('details');
          setIsModalOpen(true);
        },
        onError: () => {
          setCodeNotFoundError(true);
        }
      });
    } catch (e) {

    }
  };

  const handleDetailsSubmit = () => {
    formik.handleSubmit();
  };

  const handleSpinWheel = () => {
    setIsWheelSpinning(true);

      setTimeout(() => {
        setIsWheelSinned(true);
        setIsWheelSpinning(false);
        setIsPrizeModalOpen(true);

        if (prizeDataForced && source) {
          const params = new URLSearchParams(window.location.search);
          HttpRequest.post('/spin/proxy-to-source', {
            spinId: params.get('spinId'),
            id: params.get('id'),
            phone: params.get('phone'),
            source: params.get('source')
          });
        }
      }, 10000);
    };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsWheelSinned(false);
    setIsPrizeModalOpen(false);
      if (prizeDataForced) {
        const url = new URL(window.location.href);
        url.searchParams.delete('phone');
        url.searchParams.delete('spinId');
        url.searchParams.delete('source');
        window.history.replaceState({}, document.title, url.toString());
      }
    };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  const onClickDownloadCertificate = () => {

    //ts-ignore
    const params = new URLSearchParams({
      value: prizeData.externalId === 1 ? "100" : "500",
      checkCode: prizeData.checkCode,
      serialNumber: prizeData.serialNumber,
      externalId: prizeData.externalId,
    });

    const url = `${HttpRequest.defaults.baseURL}certificate/bodo?${params.toString()}`;

    window.open(url, "_blank");
  };

  useEffect(() => {
    if (!isModalOpen) return;
    if (step !== 'details') return;

      formik.setFieldValue('code', '');
      formik.setFieldValue('codes', ['', '', '', '']);

      if (isSuccess) {
        setStep(!isMultiCode ? 'success' : 'wheel');
      }
    }, [isSuccess]);

  useEffect(() => {
    if (!isModalOpen) return;
    if (step !== 'details') return;

      if (isError && errorMessage?.startsWith('CODE_')) {
        setCodeNotFoundError(true);
        setIsModalOpen(false);
        setStep('codes');
      }
    }, [isError, errorMessage]);

  // ── Restore prize modal from URL query ───────────────────────────────────────
  useEffect(() => {
      if (!prizeDataForced && !prizeData) return;

      try {
        setIsModalOpen(true);
        setStep('wheel');
        setIsWheelSinned(false);
        setIsPrizeModalOpen(false);
      } catch {
        console.warn('Invalid prizeData in query');
      }
    }, [prizeData, prizeDataForced]);

  // ── Render helpers ────────────────────────────────────────────────────────

  const isDetailsValid = () => {
    const required = [
      FORM_VALUE_ENUM.FIRST_NAME,
      FORM_VALUE_ENUM.PHONE,
      FORM_VALUE_ENUM.SHOP,
      FORM_VALUE_ENUM.CITY,
      FORM_VALUE_ENUM.NOVAPOST,
    ];
    return (
      required.every((f) => !formik.errors[f]) &&
      formik.values[FORM_VALUE_ENUM.AGREE]
    );
  };

  // ── Modal content by step ─────────────────────────────────────────────────

  const renderModalContent = () => {
    if (step === 'details') {
      return (
        <ModalInner>
          {/* Left side — promo illustration */}
          <ModalPromoSide>
            {!isMultiCode ? (
              <ModalPromoSingleContent>
                <MamaTextLogo
                  size={SIZE_FONT_ENUM.TITLE_LARGE}
                  type="extra-bold"
                  tid="MAMA.FORM.MODAL_SINGLE_TITLE"
                  color="yellow"
                />
                <TextElem
                  size="label"
                  tid="MAMA.FORM.MODAL_SINGLE_DESC"
                  color="white"
                  fontFamily="RF Dewi"
                />
                <ModalFireImage src={Fire} />
                <ModalFireImage2 src={Fire} />
                <ModalSinglePrizeImage src={ModalSinglePrize} />
              </ModalPromoSingleContent>
            ) : (
              <ModalPromoMultiContent>
                  <MamaTextLogo
                    size={SIZE_FONT_ENUM.TITLE_LARGE}
                    type="extra-bold"
                    tid="MAMA.FORM.MODAL_MULTI_TITLE"
                    color="yellow"
                  />
                  <TextElem
                    size="label"
                    tid="MAMA.FORM.MODAL_MULTI_DESC"
                    color="white"
                    fontFamily="RF Dewi"
                  />
                  <ModalFireImage src={Fire} />
                  <ModalFireImage2 src={Fire} />
                  <ModalMultiPrizeImage src={ModalMultiPrize} />
                </ModalPromoMultiContent>
              )}
            </ModalPromoSide>

            {/* Right side — form */}
            <ModalFormSide>
              <ModalFormTitle>
                <TextElem
                  size="heading"
                  type="extra-bold"
                  tid="AUTH.SIGNUP.DETAILS_TITLE"
                />
              </ModalFormTitle>
              <DetailsForm>
                <FormInputGridWrapper $isMultiCode={isMultiCode}>
                  <FieldTextElem
                    name={FORM_VALUE_ENUM.FIRST_NAME}
                    onChange={onChangeName}
                    onBlur={formik.handleBlur}
                    title="AUTH.SIGNUP.FIRST_NAME.TITLE"
                    value={getFieldValue(FORM_VALUE_ENUM.FIRST_NAME)}
                    errorMessage={getFieldError(FORM_VALUE_ENUM.FIRST_NAME)}
                    error={isFieldError(FORM_VALUE_ENUM.FIRST_NAME)}
                    placeholder="AUTH.SIGNUP.FIRST_NAME.PLACEHOLDER"
                  />
                  <FieldTextElem
                    name={FORM_VALUE_ENUM.PHONE}
                    onChange={onChangeName}
                    onBlur={formik.handleBlur}
                    title="AUTH.SIGNUP.PHONE.TITLE"
                    value={getFieldValue(FORM_VALUE_ENUM.PHONE)}
                    errorMessage={getFieldError(FORM_VALUE_ENUM.PHONE)}
                    error={isFieldError(FORM_VALUE_ENUM.PHONE)}
                    placeholder="AUTH.SIGNUP.PHONE.PLACEHOLDER"
                    type="phone"
                  />
                  <SelectElem
                    name={FORM_VALUE_ENUM.SHOP}
                    title="AUTH.SIGNUP.SHOP.TITLE"
                    options={SHOP_TYPE_OPTIONS}
                    placeholder="AUTH.SIGNUP.SHOP.PLACEHOLDER"
                    onChange={setFieldValue}
                    errorMessage={getFieldError(FORM_VALUE_ENUM.SHOP)}
                    error={isFieldError(FORM_VALUE_ENUM.SHOP)}
                    value={setValue(SHOP_TYPE_OPTIONS, FORM_VALUE_ENUM.SHOP)}
                  />
                  {isMultiCode && <>
                    <SelectDynamicContainer
                      name={FORM_VALUE_ENUM.CITY}
                      title="AUTH.SIGNUP.CITY.TITLE"
                      action={getCity}
                      convert={convertCity}
                      placeholder="AUTH.SIGNUP.CITY.PLACEHOLDER"
                      onChange={setFieldValue}
                      errorMessage={getFieldError(FORM_VALUE_ENUM.CITY)}
                      error={isFieldError(FORM_VALUE_ENUM.CITY)}
                      formik={formik}
                      debounce={1000}
                    />
                    <SelectDynamicContainer
                      name={FORM_VALUE_ENUM.NOVAPOST}
                      title="AUTH.SIGNUP.NOVAPOST_WAREHOUSE.TITLE"
                      action={(val: any, param: any) => getNovaPostWarehouses(val, param!)}
                      param={formik.values[FORM_VALUE_ENUM.CITY]}
                      convert={convertNovapostWarehouses}
                      placeholder="AUTH.SIGNUP.NOVAPOST_WAREHOUSE.PLACEHOLDER"
                      onChange={setFieldValue}
                      errorMessage={getFieldError(FORM_VALUE_ENUM.NOVAPOST)}
                      error={isFieldError(FORM_VALUE_ENUM.NOVAPOST)}
                      formik={formik}
                      debounce={1000}
                      preloadOnFocus
                    />
                  </>}
                </FormInputGridWrapper>

                <MamaButtonStyled
                  color={'pink'}
                  tid="MAMA.FORM.ACTIVATE_PARTICIPANT"
                  size="large"
                  type="submit"
                  onClick={handleDetailsSubmit}
                  disabled={!isDetailsValid()}
                />

                <CheckBoxHolder>
                  <CheckBoxElem
                    tid="MAMA.FORM.RULES_AGREE_WITH_RULES"
                    textSize="default"
                    name={FORM_VALUE_ENUM.AGREE}
                    checked={getFieldValue(FORM_VALUE_ENUM.AGREE)}
                    onChange={formik.handleChange}
                    isMama
                    // href={t("MAMA.RULE.BUTTON_HREF")}
                    // hrefTitle="MAMA.FORM.RULES_HREF_TITLE"
                    // hrefAnd="MAMA.FORM.RULES_AND"
                  href={t("MAMA.PERSONAL_DATA.BUTTON_HREF")}
                    hrefTitle="MAMA.FORM.PERSONAL_DATA_TITLE"
                  />
                </CheckBoxHolder>

                {isError && (
                  <MessageContainer>
                    <img src={ErrorIcon} alt="error icon" />
                  <TextElem size="default" color="black" tid={`MAMA.ERROR_MESSAGE.${errorMessage}`} />
                  </MessageContainer>
                )}
              </DetailsForm>
            </ModalFormSide>
          </ModalInner>
        );
      }

      if (step === 'success') {
        return (
          <ModalInner>
            <ModalPromoSide>
              <ModalPromoSingleContent>
                <MamaTextLogo
                  size={SIZE_FONT_ENUM.TITLE_LARGE}
                  type="extra-bold"
                  tid="MAMA.FORM.MODAL_SINGLE_TITLE"
                  color="yellow"
                />
                <TextElem
                  size="label"
                  tid="MAMA.FORM.MODAL_SINGLE_DESC"
                  color="white"
                  fontFamily="RF Dewi"
                />
                <ModalIphoneImage src={Iphone} />
                <ModalFireImage src={Fire} />
                <ModalFireImage2 src={Fire} />
              </ModalPromoSingleContent>
            </ModalPromoSide>
            <ModalFormSide>
              <SuccessContainer>
                <SuccessIcon>✓</SuccessIcon>
                <TextElem size="heading" type="extra-bold" color="black" tid="MAMA.FORM.CODE_ACCEPTED_TITLE" />
                <TextElem size="default" color="black" tid="MAMA.FORM.CODE_ACCEPTED_DESC" />
                <TextElem size="medium" color="black" tid={"MAMA.FORM.SAVE_STICKER"} />
              </SuccessContainer>
            </ModalFormSide>
          </ModalInner>
        );
      }

      if (step === 'wheel') {
        return (
          <WheelModalInner>
            {/* Left — text + button */}
            <WheelTextSide>
              <div>
                <div>
                  <MamaTextLogo
                    color="yellow"
                    size={SIZE_FONT_ENUM.TITLE_LARGE}
                    type="extra-bold"
                    tid="MAMA.HOME.SPIN_WHEEL_OF_FORTUNE_CONDITION"
                  />
                </div>
                <MamaTextLogo
                  color="white"
                  size={SIZE_FONT_ENUM.TITLE_LARGE}
                  type="extra-bold"
                  tid="MAMA.HOME.SPIN_WHEEL_OF_FORTUNE_TIME"
                />
              </div>
              <HeroCardStyled>
                <HeroCardImage src={HeroCardPink} />
                <HeroCardTextStyled color="white" size="main" tid="MAMA.HOME.SPIN_WHEEL_OF_FORTUNE_DESC" />
              </HeroCardStyled>
              {!isWheelSinned && (
                <SpinButtonHolder>
                  <MamaButton
                    color="yellow"
                    tid="MAMA.HOME.SPIN_WHEEL_BUTTON"
                    size="large"
                    onClick={handleSpinWheel}
                    disabled={isWheelSpinning || isLoading}
                  />
                </SpinButtonHolder>
              )}
            </WheelTextSide>
            {/* {console.log('prizeData', prizeData)} */}
            {/* Right — wheel */}
            <WheelVisual>
              <WheelAction
                spinValue={(!!prizeData && prizeData?.imgId) || 0}
                startSpinning={isWheelSpinning} // || !!prizeData
              />
            </WheelVisual>
          </WheelModalInner>
        );
      }

      return null;
    };

  return (
    <PageWrapper>
      {isLoading && <LoaderElem />}

        {/* ── Step 1: Two code cards ── */}
        <CardsRow>
          {/* Single code card */}
          <CodeCard $active={!isMultiCode} $dim={isMultiCode} alternative onFocus={() => setIsMultiCode(false)}>
            <CardTitle>
              <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.FORM.SINGLE_TITLE_KEY" color='yellow' />
              <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.FORM.SINGLE_TITLE" color='white' />
            </CardTitle>
            <CardDescSingleCode>
              <TextElem size="label" tid="MAMA.FORM.SINGLE_DESC" color='white' fontFamily='RF Dewi' />
            </CardDescSingleCode>

            <CodesIphoneImage src={Iphone2} />
            <CodesFireImage src={Fire} />
            <CodesFireImage2 src={Fire} />

            <CodeCardFrame style={{ marginTop: 'auto' }}>
              <FieldTextElem
                name={FORM_VALUE_ENUM.CODE}
                onChange={onChangeCodeMasked}
                onBlur={formik.handleBlur}
                title="AUTH.SIGNUP.CODE.TITLE"
                value={applyCodeMask(getFieldValue(FORM_VALUE_ENUM.CODE) || '')}
                errorMessage={getFieldError(FORM_VALUE_ENUM.CODE)}
                error={isFieldError(FORM_VALUE_ENUM.CODE)}
                placeholder="AUTH.SIGNUP.CODE.PLACEHOLDER_X"
              // maxLength={CODE_LENGTH}
              />
            </CodeCardFrame>

            <MamaButtonHolder>
              <MamaButton
                color="yellow"
                tid="AUTH.SIGNUP.SEND_CODE"
                size="large"
                onClick={() => isSingleCodeFilled() && handleCodeSubmit(false)}
                disabled={!isSingleCodeFilled()}
              />
            </MamaButtonHolder>
            {codeNotFoundError && !isMultiCode && (
              <MessageContainer>
                <img src={ErrorIcon} alt="error icon" />
              <TextElem size="default" color="black" tid={`MAMA.ERROR_MESSAGE.${errorMessage || getErrorMessage()}`} />
              </MessageContainer>
            )}
          </CodeCard>

          {/* Multi code card */}
          <CodeCard $active={isMultiCode} $dim={!isMultiCode} onFocus={() => setIsMultiCode(true)}>
            <CardTitle>
              <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.FORM.MULTI_TITLE_KEY" color='yellow' />
              <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.FORM.MULTI_TITLE" color='white' />
            </CardTitle>
            <CardDesc>
              <TextElem size="label" tid="MAMA.FORM.MULTI_DESC" color='white' fontFamily='RF Dewi' />
            </CardDesc>

            <CodesRtWheel src={RtWheel} />

            <CodesGrid>
              <CodeCardFrame >
                {formik.values[FORM_VALUE_ENUM.CODES]?.map((code: string, index: number) => {
                  const codesErrors = formik.errors[FORM_VALUE_ENUM.CODES] as (string | undefined)[] | undefined;
                  const codesError = Array.isArray(codesErrors) ? codesErrors[index] : undefined;
                  const touched = !!formik.touched[FORM_VALUE_ENUM.CODES];

                  return (
                    <FieldTextElem
                      key={index}
                      name={`${FORM_VALUE_ENUM.CODES}[${index}]`}
                      onChange={onChangeCodeMasked}
                      onBlur={formik.handleBlur}
                      title={`AUTH.SIGNUP.CODE.TITLE_${index + 1}`}
                      value={applyCodeMask(getFieldValue(FORM_VALUE_ENUM.CODES)?.[index] || '')}
                      errorMessage={touched ? codesError : undefined}
                      error={touched && !!codesError}
                      // maxLength={CODE_LENGTH}
                      placeholder="AUTH.SIGNUP.CODE.PLACEHOLDER_X"
                    />
                  );
                })}
              </CodeCardFrame>
            </CodesGrid>

            <MamaButtonHolder>
              <MamaButton
                color="yellow"
                tid="AUTH.SIGNUP.SEND_CODE"
                size="large"
                onClick={() => isMultiCodeFilled() && handleCodeSubmit(true)}
                disabled={!isMultiCodeFilled()}
              />
            </MamaButtonHolder>
            {codeNotFoundError && isMultiCode && (
              <MessageContainer>
                <img src={ErrorIcon} alt="error icon" />
              <TextElem size="default" color="black" tid={`MAMA.ERROR_MESSAGE.${errorMessage || getErrorMessage()}`} />
              </MessageContainer>
            )}
          </CodeCard>
        </CardsRow>
        {/* ── Modal for steps 2 & 3 ── */}
        <ModalOverlay isOpen={isModalOpen} onClick={handleOverlayClick}>
          <ModalWrapper onClick={handleOverlayClick}>
            <ModalContent isOpen={isModalOpen} $step={step}>
              <CloseButton onClick={handleCloseModal}>
                <img src={Close} alt="close" />
              </CloseButton>
              {renderModalContent()}
            </ModalContent>
          </ModalWrapper>
        </ModalOverlay>
        <PrizeModalOverlay isOpen={isPrizeModalOpen}>
          <PrizeModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => handleCloseModal()}>
              <img src={Close} alt="close" />
            </CloseButton>
            {(
              <>

                <div>
                  <div>
                    <TextElem size="heading" color="black" tid="MAMA.FORM.CONGRATULATIONS" />
                  </div>
                  <div>
                  <TextElem size="heading" color="black" tid="MAMA.FORM.WIN_GIFT" />
                  (<TextElem size="heading" color="black" tid={(prizeData?.name) + "!"} />)
                  </div>
                </div>
                <PrizeModalImage src={[PresentImg, Prize1, Prize2, Prize3, Prize4, Prize5, Prize6][prizeData?.imgId || 0]} alt="prize" />

              {/* {(prizeData?.imgId === 3 || prizeData?.imgId === 6) && <>
                  <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_ACTIVATE_LINK" />
                  <LinkStyled href={t("MAMA.FORM.BODO_ACTIVATE_LINK_HREF")} target="_blank">
                    <TextElem size="title" color="black" tid={"MAMA.FORM.BODO_ACTIVATE_LINK_HREF"} />
                  </LinkStyled>
                </div>
                <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_SERIAL_NUMBER" />
                  <TextElem size="title" color="black" tid={prizeData?.serialNumber} />
                  </div>
                  <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_CHECK_CODE" />
                  <TextElem size="title" color="black" tid={prizeData?.checkCode} />
                  </div>
                  <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_EXPIRY_DATE" />
                  <TextElem size="title" color="black" tid={prizeData?.expiry} />
                  </div>
                  <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_CERTIFICATE_LINK" />
                    <LinkStyled href={prizeData?.link} target="_blank">
                    <TextElem size="title" color="black" tid={prizeData?.link} />
                    </LinkStyled>
                  </div>
                  <div>
                  <TextElem size="title" color="black" tid="MAMA.FORM.BODO_PASSWORD" />
                  <TextElem size="title" color="black" tid={prizeData?.password} />
                  </div>
                </>
                }

                {(prizeData?.imgId !== 3 && prizeData?.imgId !== 6) && <TextElem size="medium" color="black" tid={"MAMA.FORM.DELIVERY"} />} */}
              {/* <TextElem size="medium" color="black" tid={"MAMA.FORM.SAVE_STICKER"} /> */}



              {(prizeData?.imgId === 3 || prizeData?.imgId === 6) && <>
                <MamaButtonStyled
                  tid="MAMA.FORM.DOWNLOAD_CERTIFICATE"
                  color='pink'
                  onClick={() => onClickDownloadCertificate()}
                >
                  <TextElem size="title" color="white" type="bold" tid="MAMA.FORM.DOWNLOAD_CERTIFICATE" />
                </MamaButtonStyled>
              </>
              }

                {(prizeData?.imgId !== 3 && prizeData?.imgId !== 6) && <TextElem size="medium" color="black" tid={"MAMA.FORM.DELIVERY"} />}


                {source && prizeDataForced && <MamaButtonStyled
                  tid="MAMA.FORM.BACK_TO_BOT"
                  color='pink'
                  onClick={() => onClickBackToSource()}
                >



                  <TextElem size="title" color="white" type="bold" tid="MAMA.FORM.RECEIVE_PRIZE" />
                </MamaButtonStyled>}
                <PresentDecorWrapper>
                  <img src={PresentImg} alt="" />
                  <img src={PresentImg} alt="" />
                  <img src={PresentImg} alt="" />
                </PresentDecorWrapper>
              </>
            )}

          </PrizeModalContent>
        </PrizeModalOverlay >
      </PageWrapper >
    );
  };

// ─── Animations ───────────────────────────────────────────────────────────────

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const popIn = keyframes`
  0%   { transform: scale(0.8); opacity: 0; }
  70%  { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
`;

// ─── Layout ───────────────────────────────────────────────────────────────────

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
`;

const CardsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// ─── Code Cards ───────────────────────────────────────────────────────────────

const CodeCard = styled.div<{ $active?: boolean; $dim?: boolean; alternative?: boolean }>`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 44px;
  border-radius: 24px;
  position: relative;
  overflow: hidden;

  input {
    font-family: 'Dela Gothic One' !important;
  }

  background: ${({ alternative }) =>
    alternative
      ? 'linear-gradient(180deg, #FF0480 0%, #97003C 100%)'
      : 'linear-gradient(0deg, #FF5100 30.5%, #FFA67D 100%)'};

  transition: opacity 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;

  /* opacity: ${({ $dim }) => ($dim ? 0.45 : 1)}; */
  transform: ${({ $active }) => ($active ? 'scale(1.01)' : 'scale(1)')};
  box-shadow: ${({ $active }) =>
    $active
      ? '0 8px 40px rgba(227, 37, 49, 0.18)'
      : '0 2px 16px rgba(0,0,0,0.07)'};
  /* pointer-events: ${({ $dim }) => ($dim ? 'none' : 'auto')}; */

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const CodeCardFrame = styled.div`
  /* max-width: 278px; */
  padding: 12px 12px 0 12px;
  background: linear-gradient(180deg, #FFCD00 48.89%, #F2740C 100%);
  box-shadow: 0px 10px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  position: relative;

  input {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    /* text-overflow: ellipsis; */
    width: 100%;
    padding: 10px 12px;
    letter-spacing: 10px;
    font-size: 22px;
    padding-bottom: 15px;
    font-weight: normal;
    font-family: 'RF Dewi' !important;
    text-align: center;

    @media (max-width: 1080px) {
      font-size: 18px;
      letter-spacing: 10px;
    }

    @media (max-width: 768px) {
      /* border-radius: 15px 0 0 15px; */
      font-size: 18px;
      line-height: 32px;
      letter-spacing: 10px;
      padding-bottom: 12px;

    ::placeholder {
      font-size: 16px;
      letter-spacing: 16px;
      color: #bbbbbb;
      padding: 6px;
    } 
    }

    @media (max-width: 400px) {
      letter-spacing: 6px;
    }

    ::placeholder {
      font-size: 16px;
      letter-spacing: 28px;
      color: #bbbbbb;
      padding: 6px;
      font-family: 'Dela Gothic One' !important;
    } 
  }

  > div > div:first-child {
    display: none;
    > span {

      line-height: 1;

      @media (max-width: 1200px) {
        font-size: 14px;
      }

      font-size: 16px;
    }
    padding: 9px 0 9px 12px;
    margin: 0 -10px;

    @media (max-width: 500px) {
      width: 100%;
    }
  }

  /* @media (max-width: 768px) {
    width: calc(100% + 40px);
    max-width: none;
  } */
`;

const CardTitle = styled.div`
  margin-top: 4px;
`;

const CardDesc = styled.div`
  color: #666;
  margin-bottom: 4px;
`;

const CodesGrid = styled.div`
  /* display: grid; */
  /* grid-template-columns: 1fr 1fr; */
  width: 100%;

  padding: 24px 0px 12px 0;
  gap: 12px;
  margin-top: auto;
  align-self: center;

  @media (max-width: 544px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;

const CodesIphoneImage = styled.img`
  position: absolute;
  right: 50px;
  bottom: 90px;
  rotate: -10deg;
  z-index: -1;
  width: 150px;

  @media screen and (max-width: 1100px) {
    width: 100px;
  }

  @media screen and (max-width: 500px) {
    width: 80px;
    right: 0px;
  }
`;

const CodesFireImage = styled.img`
  position: absolute;
  top: -10px;
  right: 60px;
  z-index: -1;
  width: 80px;
  rotate: -40deg;
`;

const CodesFireImage2 = styled.img`
  position: absolute;
  top: 150px;
  right: 10px;
  z-index: -1;
  width: 150px;

  @media screen and (max-width: 770px) {
    top: 60px;
    right: -20px;
    width: 80px;
  }
`;

const CodesRtWheel = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  width: 270px;

  @media (max-width: 640px) {
    width: 170px;
  }
`;

// ─── Modal ────────────────────────────────────────────────────────────────────

const ModalOverlay = styled.div<{ isOpen: boolean }>`
  z-index: 400;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  overflow-y: auto;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const ModalWrapper = styled.div`
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const ModalContent = styled.div<{ isOpen: boolean; $step: Step }>`
  position: relative;
  width: 100%;

  max-width: ${({ $step }) => ($step === 'wheel' ? '1230px' : '1230px')};
  border-radius: 24px;
  overflow: hidden;
  background: ${({ $step }) =>
    $step === 'wheel'
      ? 'linear-gradient(135deg, #FF0480 0%, #97003C 100%)'
    : 'transparent'};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: translateY(${({ isOpen }) => (isOpen ? 0 : '-20px')});
  transition: opacity 0.3s ease, transform 0.3s ease;
  animation: ${slideDown} 0.35s ease;
`;

const CloseButton = styled.button`
  cursor: pointer;
  padding: 4px;
  position: absolute;
  top: 16px;
  right: 16px;
  max-width: 64px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

// ─── Modal Inner layouts ──────────────────────────────────────────────────────

const ModalInner = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
    min-height: 700px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const ModalPromoSide = styled.div`
  position: relative;
  overflow: hidden;
  padding: 40px 32px;
  background: linear-gradient(180deg, #FF0480 0%, #97003C 100%);
  display: flex;
  flex-direction: column;
  border-radius: 23px;
  margin-right: 5px;

  @media screen and (max-width: 700px) {
    /* display: none; */
    min-height: 550px;
    margin-right: inherit;
    margin-bottom: 5px;
  }

`;

const ModalPromoSingleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  z-index: 1;
`;

const ModalPromoMultiContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

const ModalIphoneImage = styled.img`
  position: absolute;
  right: -20px;
  bottom: -20px;
  width: 220px;
  z-index: 0;
`;

const ModalSinglePrizeImage = styled.img`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 20px;
  max-width: 500px;
  width: 100%;
  z-index: 0;

  @media (max-width: 700px) {
    max-width: 100%;
    width: auto;
    max-height: 300px;
  }
`;

const ModalFireImage = styled.img`
  position: absolute;
  top: 190px;
  right: 80px;
  z-index: 0;
  width: 70px;
  rotate: -40deg;

    @media (max-width: 640px) {
    width: 60px;
  }
`;

const ModalFireImage2 = styled.img`
  position: absolute;
  top: 250px;
  right: 10px;
  z-index: 0;
  width: 120px;

  @media (max-width: 640px) {
    width: 70px;
  }
`;


const ModalMultiPrizeImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 0;
  max-height: 500px;
  @media (max-width: 1080px) {
    max-height: 400px;
  }

  @media (max-width: 700px) {
    max-height: 300px;
  }
`;

const ModalFormSide = styled.div`
  padding: 40px 32px;
  background: linear-gradient(180deg, #FFCD00 48.89%, #F2740C 100%);
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  border-radius: 23px;
   margin-left: 5px;

  @media (max-width: 544px) {
    padding: 32px 24px;
    margin-top: 5px;
    margin-left: inherit;
  }
`;

const ModalFormTitle = styled.div`
  text-align: center;
`;

// ─── Details form ─────────────────────────────────────────────────────────────

const DetailsForm = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 14px; */
`;

// ─── Success ─────────────────────────────────────────────────────────────────

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1;
  padding: 40px 28px;
  text-align: center;
  animation: ${popIn} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
`;

const SuccessIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 77, 128, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #ff0480;
`;

// ─── Wheel (inside modal) ─────────────────────────────────────────────────────

const WheelModalInner = styled.div`
  display: flex;
  
  justify-content: space-between;
  gap: 32px;
  padding: 48px 40px;
  background: linear-gradient(180deg, #FF0480 0%, #97003C 100%);


  @media (max-width: 1100px) {
    align-items: center;
    flex-direction: column;
    padding: 32px 20px;
  }
`;

const WheelTextSide = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
  min-width: 260px;
  max-width: 560px;
  z-index: 1;
  /* align-items: center; */

  @media (max-width: 768px) {
     gap: 16px;
  }
`;

const WheelVisual = styled.div`
  flex-shrink: 0;
  max-width: 544px;
  padding-top: 20px;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const SpinButtonHolder = styled.div`
  padding-top: 32px;
  @media (max-width: 768px) {
    margin: auto;
  }
`;

// ─── Error ────────────────────────────────────────────────────────────────────

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 14px;
  border-radius: 12px;
  margin-top: 12px;
  background: #fff3f3;
  gap: 10px;
  border: 1px solid #ffd0d0;
`;

const PrizeModalOverlay = styled.div<{ isOpen: boolean }>`
  z-index: 500;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const PrizeModalContent = styled.div`
  position: relative;
  background: linear-gradient(180deg, #FFCD00 0%, #F2740C 100%);
  border-radius: 24px;
  padding: 48px 40px;
  max-width: 635px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  animation: ${popIn} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1;
`;

const PrizeModalImage = styled.img`
  width: 220px;
  object-fit: contain;
`;

const PresentDecorWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.5));

  > img:nth-child(1) {
            position: absolute;
    width: 120px;
    top: 16px;
    left: -12px;
    rotate: 10deg;
    pointer-events: none;
    z-index: 0;
    rotate: -20deg;
    filter: blur(3px);


    @media (max-width: 480px) {
      /* width: 50px; */
    }
  }

  > img:nth-child(2) {
        position: absolute;
    width: 100px;
    top: 30%;
    right: 15%;
    rotate: 15deg;
    pointer-events: none;
    z-index: 0;
    rotate: 20deg;

    @media (max-width: 480px) {
      right: -10px;
    }
  }

  > img:nth-child(3) {
    position: absolute;
    width: 70px;
    bottom: 25%;
    left: 20%;
    rotate: -20deg;
    pointer-events: none;
    z-index: 0;

    @media (max-width: 480px) {
      /* width: 55px; */
      left: 5%;
    }
  }

  > *:not(img) {
    position: relative;
    z-index: 1;
  }
`;

const MamaButtonHolder = styled.div`

  @media (max-width: 768px) {
    margin: 0 auto;
  }

  @media (max-width: 375px) {
     > button {
      padding: 0 16px;
      > span:first-child {
        font-size: 14px;
      }
    }
  }
`;

const FormInputGridWrapper = styled.div<{ $isMultiCode: boolean }>`
  @media (min-width: 1231px) {
  display: ${({ $isMultiCode }) => ($isMultiCode ? "grid" : "contents")};

  ${({ $isMultiCode }) =>
    $isMultiCode &&
    css`
      grid-template-columns: 1fr 1fr;
      gap: 8px 12px;

      > :nth-child(5) {
        grid-column: 1 / -1;
      }
    `}
  }


  @media (max-width: 1230px) {
    display: contents;
    font-size: 16px;
  }

  .Select__control, 
  .react-tel-input input 
  input:not(.react-tel-input input),
  input:not(.Select__control input) {
    min-height: 50px;
    border-radius: 12px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  * {
    font-family: "Dela Gothic One" !important;
  }
`;

const MamaButtonStyled = styled(MamaButton)`
  border-radius: 16px;

  @media (max-width: 375px) {
    padding: 0 5px;
  }
`;

const CheckBoxHolder = styled.div`
  padding-top: 16px;
  margin: auto;
`;

const HeroCardStyled = styled(HeroCard)`
    @media screen and (max-width: 540px) {
    height: 100px;
    width: 330px;
  }

  @media screen and (max-width: 375px) {
    width: 280px;
  }
`;

const HeroCardTextStyled = styled(HeroCardText)`

  font-size: 20px;
  margin: 10px;

  @media screen and (max-width: 540px) {
    font-size: 16px;
    margin: 0;
  }

  @media screen and (max-width: 375px) {
    font-size: 12px;
  }
`;

const CardDescSingleCode = styled(CardDesc)`
  @media (max-width: 615px) {
    max-width: 70%;
  }
`

const LinkStyled = styled.a`
  transition: 0.3s opacity ease;

  :hover {
    opacity: 0.7;
  }
`;